<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>Person {{ applicant.pseudonym.label }} kontaktieren</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<div>
				<ContactPurchase
					v-model="contactData"
					:job-profile-id="jobProfileId"
					:job-id="jobId"
					:pseudonym="applicant.pseudonym"
					type="contacting"
					initiator="customer"
					@purchase="close({contacted: true})"
				/>
			</div>
		</main>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import ContactPurchase from "@/vue/communication/ContactPurchase";
import {isDefined} from "@/helper/Value";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/communication/contact-applicant";

export default {

	components: {
		Button,
		Icon,
		ContactPurchase,
	},

	data ()
	{
		return {
			contactData: undefined,
			contacting: false
		};
	},

	computed: {
		...mapState('communication/contactApplicant', [
			'show',
			'jobProfileId',
			'jobId',
			'applicant',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		dataValid ()
		{
			return isDefined(this.contactData);
		},
	},

	methods: {
		...mapActions('communication/contactApplicant', [
			'close'
		]),
	},
}
</script>
